import Card from "./card.svg?react";
import "./styles.scss";

export interface IPaymentBreakdown {
  amount: string;
}
export const PriceBreakdown = (props: IPaymentBreakdown) => {
  const { amount } = props;
  return (
    <div className="fintech-price-breakdown icon-card-container">
      <div className="icon-card-icon">
        <Card />
      </div>
      <div className="fintech-price-breakdown-info icon-card-details">
        {amount}
      </div>
    </div>
  );
};
